module.exports = __webpack_public_path__ + "static/media/honeybee.c974fce3.png";